import { HTTP_STATUS_OK } from "../smartpak/httpstatus";

const HIDE_CLASS = 'jsHide',
    customerView = {
        setCartItemCount: function (count) {
            if (isNaN(count)) {
                return;
            }

            const $itemCount = document.getElementById('itemCount');

            if ($itemCount) {
                const $badge = $itemCount.querySelector('.cart-badge');

                if (count === 0) {
                    $itemCount.classList.add(HIDE_CLASS);
                    return;
                }

                if ($badge) {
                    $badge.innerHTML = count;
                    $itemCount.classList.remove(HIDE_CLASS);
                }
            }
        },

        setLoginStatus: function (isLoggedIn) {
            const $login = document.getElementById('nav-account-first-focus');

            if ($login) {
                if (!isLoggedIn) {
                    $login.href = `/account/login?returnUrl=${encodeURIComponent(location.pathname+location.search)}&create=true`;
                    $login.innerText = 'Sign in';
                } else {
                    $login.href = '/account/signout';
                    $login.innerText = 'Sign Out';
                }
                $login.classList.remove(HIDE_CLASS);
            }
        },

        setFirstName: function (name) {
            Array.from(document.querySelectorAll('.custFirstName')).forEach($element => ($element.innerHTML = name));
        },

        setGreeting: function (name) {
            const $greeting = document.getElementById('account-greeting');

            if ($greeting && name) {
                $greeting.innerHTML = `Hi, ${name}`;
                $greeting.classList.remove(HIDE_CLASS);
            }
        },

        setAccountLink: function (customer) {
            const $account = document.getElementById('mobile-account-link');

            if ($account) {
                $account.innerHTML =
                    customer.isLoggedIn || customer.isCookiedIn
                        ? `<span class="account-greeting">Hi, ${customer.firstName}</span>&nbsp;|&nbsp;Account`
                        : 'Sign in&nbsp;|&nbsp;Account';
            }
        },

        setSmartPaksNavList: function ($navigation) {
            const $managerLink = $navigation.querySelector('[href="#smartpak-manager-link"]');
            const $button = $navigation.querySelector('#build-smartpaks-button .text');
            const $mySmartPaks = document.querySelectorAll('.smartpak-management-url');

            if ($managerLink) {
                fetch('/api/recipient/GetFirstDisplayableRecipientId/1')
                    .then(r => r.json())
                    .then(r => {
                        if (r.Status === HTTP_STATUS_OK) {
                            $managerLink.href = `/autoshipmanager/supplements/${r.Content}`;
                            [...$mySmartPaks].forEach($link => $link.href = `/autoshipmanager/supplements/${r.Content}`);
                        }
                    });
            }

            if ($button) {
                $button.innerHTML = 'Manage SmartPaks';
            }
        },

        checkBackOrderItem: function (hasActionableClaims) {
            const $backOrderItem = document.getElementById('back-order-item-msg');

            if ($backOrderItem) {
                $backOrderItem.classList[hasActionableClaims ? 'remove' : 'add'](HIDE_CLASS);
            }
        },

        addMobileColicareMessage: function (horseName) {
            const $ribbon = document.getElementById('site-ribbon'),
                message = `<div>${horseName} is eligible to apply for ColiCare. <span class="colicareFinePrint">Don't miss out on $15,000! <a href="/colicare/registration">Apply now</a></span></div>`;

            if (!$ribbon) {
                return;
            }

            let $list = $ribbon.querySelector('ul'),
                $listItem = document.createElement('li');

            if ($list) {
                $listItem.id = 'colicare-ribbon-message';
                $listItem.innerHTML = message;
                $list.appendChild($listItem);
            }
        },

        showCreditCardMessage: function () {
            const $acctUpdate = document.getElementById('custAcctUpdate');

            if ($acctUpdate) {
                $acctUpdate.style.display = 'inline';
            }
        },

        showContactUsMessage: function () {
            const $contactUs = document.getElementById('custContactUs');

            if ($contactUs) {
                $contactUs.style.display = 'inline';
            }
        }
    };

export default customerView;
